// extracted by mini-css-extract-plugin
export default {"root":"vJtpgNhVrn","backContainer":"HmiuwfIhfA","content":"JEa0lfUnCK"};